import { Component } from 'react'
import {
  Switch,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
} from '@material-ui/core'
import RoomIcon from '@material-ui/icons/Room'
import PropTypes from 'prop-types'

class DistanceItem extends Component {
  constructor(props) {
    super(props)

    this.state = {
      checkedDistance: this.props.distanceFlagFromParent,
    }
  }

  handleChange = (name) => (event) => {
    this.setState({ checkedDistance: event.target.checked })
    this.props.callbackFromParentDistanceFlag(event.target.checked)
  }

  handleLabel(distanceValue) {
    var labelText = 'Only contact by work location'
    if (distanceValue) {
      labelText = 'Contact nearby team members'
    }
    return labelText
  }

  render() {
    return (
      <div>
        <List className={this.props.className}>
          <ListItem>
            <ListItemIcon>
              <RoomIcon />
            </ListItemIcon>
            <ListItemText
              primary={this.handleLabel(this.state.checkedDistance)}
            />
            <ListItemSecondaryAction>
              <Switch
                checked={this.state.checkedDistance}
                onChange={this.handleChange('checkedDistance')}
                value="checkedDistance"
              />
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </div>
    )
  }
}

export default DistanceItem

DistanceItem.propTypes = {
  distanceFlagFromParent: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  callbackFromParentDistanceFlag: PropTypes.func.isRequired,
}
